import React from 'react';

import { ConditionItem, IConditionItem } from 'components/ConditionItem/ConditionItem';

import styles from './ConditionItems.module.scss';

interface IConditionItems {
  items: Array<IConditionItem>;
}

export const ConditionItems: React.VFC<IConditionItems> = ({ items }) => (
  <section>
    <h2 className={styles.title}>Skick</h2>
    <div className={styles.wrapper}>
      {items.map((item) => (
        <ConditionItem
          key={item.title}
          title={item.title}
          color={item.color}
          text={item.text}
          limit={item.limit}
          titleIcon={item.titleIcon}
        />
      ))}
    </div>
  </section>
);
